export enum APP_ROUTES {
  MAIN = "/",
  // LET_IT_BE = "/let_it_be",

  // m_lounge
  M_LOUNGE = "/m_lounge",
  M_LOUNGE_MENU = "/m_lounge/menu",
  M_LOUNGE_BIZNES_LANCH = "/m_lounge/biznes-lanch",
  M_LOUNGE_ABOUT_AS = "/m_lounge/about-as",
  M_LOUNGE_REVIEWS = "/m_lounge/reviews",
  M_LOUNGE_CONTACTS = "/m_lounge/contacts",

  // golodnii_krolik
  GOLODNII_KROLIK = "/golodnii_krolik",
  GOLODNII_KROLIK_MENU = "/golodnii_krolik/menu",
  GOLODNII_KROLIK_ABOUT_AS = "/golodnii_krolik/about-as",
  GOLODNII_KROLIK_CONTACTS = "/golodnii_krolik/contacts",

  NOT_FOUND = "*",
}
